module.exports = __webpack_public_path__ + "img/lg_ring_r_s_0_null@2x.2ae2fa7f.png";